






















import Vue from 'vue'

export default Vue.extend({
  name: 'TextInput',

  props: {
    name: String,
    label: String,
    onChange: Function,
    multiline: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'text',
    },
    value: String,
  },

  computed: {
    requiredTag() {
      return this.required ? '*' : ''
    },
  },

  methods: {
    handleInputChange(event: Event) {
      const target = event.target as HTMLInputElement
      const { name, value } = target
      this.onChange(name, value)
    },
  },
});
